import axios from "axios";

// iter69-B — captura global de beforeinstallprompt (Android/Chrome 1-tap install).
// Debe importarse temprano (index.js) para no perder el evento.
let deferredPrompt = null;
let installed = false;
const listeners = new Set();

export function getInstallPromptState() {
  return { promptAvailable: !!deferredPrompt, installed };
}

export function subscribeInstallPrompt(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

const notify = () => listeners.forEach((fn) => { try { fn(getInstallPromptState()); } catch (_) {} });

export function logInstallEvent(event) {
  try { axios.post("/api/push/install-event", { event }); } catch (_) { /* observability only */ }
}

export async function promptInstall() {
  if (!deferredPrompt) return null;
  const ev = deferredPrompt;
  logInstallEvent("prompted");
  let outcome = null;
  try {
    ev.prompt();
    const choice = await ev.userChoice;
    outcome = choice?.outcome || null;
    logInstallEvent(outcome === "accepted" ? "accepted" : "dismissed");
  } catch (_) { /* prompt can only be used once */ }
  deferredPrompt = null;
  notify();
  return outcome;
}

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    notify();
  });
  window.addEventListener("appinstalled", () => {
    installed = true;
    deferredPrompt = null;
    logInstallEvent("installed");
    notify();
  });
}
